import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { Heading } from '@grandvisionhq/elements';
import { Form, RequiredFieldsLabel, DatePicker, CheckboxWithLabel } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import Optician, { OpticianType } from './Optician/Optician.js';

const createExternalOpticianInfo = (formState)=>{
    const obj = Object.entries(formState).reduce((acc, [key, field])=>swcHelpers.objectSpread({}, acc, {
            [key]: field ? field.value : ''
        })
    , {});
    return JSON.stringify(obj);
};
const isInfoValid = (state, opticianType, isPrescriptionExtraInfoEnabled = true)=>{
    const { prescriptionExpiryDate , externalOptician , consent  } = state;
    // when isPrescriptionExtraInfoEnabled is false, having consent is enough to continue
    if (!isPrescriptionExtraInfoEnabled && consent) {
        return true;
    }
    if (!prescriptionExpiryDate || !consent) {
        return false;
    }
    if (opticianType === OpticianType.External && !externalOptician) {
        return false;
    }
    return true;
};
const getMaxExpiryDate = ()=>{
    const maxYears = 5;
    const date = new Date();
    date.setFullYear(date.getFullYear() + maxYears);
    return date;
};
const PrescriptionInfo = ({ onChange , opticianForm , isPrescriptionExtraInfoEnabled =true , prescriptionInfoAdditionalContent ,  })=>{
    const { getLabel  } = useIntl();
    const [expiryDate, setExpiryDate] = React__default.useState();
    const [opticianType, setOpticianType] = React__default.useState(OpticianType.Internal);
    const [opticianInfo, setOpticianInfo] = React__default.useState();
    const [consent, setConsent] = React__default.useState(false);
    const handleExpiryDateChange = React__default.useCallback((date)=>{
        setExpiryDate(date);
    }, []);
    const handleOpticianTypeChange = React__default.useCallback((type)=>{
        setOpticianType(type);
    }, []);
    const handleOpticianFormChange = React__default.useCallback((form)=>{
        if (form.formValid) {
            setOpticianInfo(form.formState);
        }
    }, []);
    const handleConsentChange = React__default.useCallback(({ checked  })=>{
        setConsent(checked);
    }, []);
    const state = React__default.useMemo(()=>swcHelpers.objectSpread({
            prescriptionExpiryDate: expiryDate && expiryDate.toISOString()
        }, opticianType === OpticianType.External ? {
            externalOptician: opticianInfo && createExternalOpticianInfo(opticianInfo)
        } : null, {
            consent
        })
    , [
        expiryDate,
        opticianType,
        opticianInfo,
        consent
    ]);
    React__default.useEffect(()=>{
        if (onChange) {
            onChange(swcHelpers.objectSpread({}, state, {
                valid: isInfoValid(state, opticianType, isPrescriptionExtraInfoEnabled)
            }));
        }
    }, [
        onChange,
        state,
        opticianType
    ]);
    const OpticianForm = /*#__PURE__*/ React__default.createElement(Form, {
        name: "opticianForm",
        "data-t": "optician-form",
        className: "prescription-info-optician__form",
        initialFormState: opticianInfo,
        onChange: handleOpticianFormChange
    }, opticianForm && opticianForm());
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        className: "prescription-info__heading",
        variant: "smallest"
    }, getLabel('products.contactLenses.info.title')), /*#__PURE__*/ React__default.createElement(RequiredFieldsLabel, null), prescriptionInfoAdditionalContent, isPrescriptionExtraInfoEnabled && /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info__dates"
    }, /*#__PURE__*/ React__default.createElement(DatePicker, {
        label: getLabel('products.contactLenses.info.expiryDate.label'),
        tooltip: getLabel('products.contactLenses.info.expiryDate.hint'),
        errorMessage: getLabel('products.contactLenses.info.expiryDate.errorMessage'),
        placeholder: getLabel('common.selectDate'),
        initialValue: expiryDate,
        onChange: handleExpiryDateChange,
        maxDate: getMaxExpiryDate()
    })), /*#__PURE__*/ React__default.createElement(Optician, {
        opticianForm: OpticianForm,
        selectedOpticianType: opticianType,
        onOpticianTypeChange: handleOpticianTypeChange
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info__consent"
    }, /*#__PURE__*/ React__default.createElement(CheckboxWithLabel, {
        className: "prescription-info__checkbox",
        id: "prescription-info-consent",
        value: "prescription-info-consent",
        checked: consent,
        onChange: handleConsentChange,
        label: getLabel('products.contactLenses.info.consent'),
        errorMessage: ""
    })));
};
var PrescriptionInfo$1 = PrescriptionInfo;

export { PrescriptionInfo, createExternalOpticianInfo, PrescriptionInfo$1 as default, getMaxExpiryDate, isInfoValid };
//# sourceMappingURL=PrescriptionInfo.js.map
